import { useSelector } from 'react-redux'
import { Panel } from '../../../common/panel'
import { selectAssociateCompanyIds } from '../store/slice'
import { downloadAssociatedCompany } from '../store/thunk'
import { AssociateCompanyTable } from './AssociateCompanyTable'

export const AssociateCompanies = ({ organizationId }) => {
  const ids = useSelector(selectAssociateCompanyIds)

  return (
    <Panel
      id="associates"
      isI18n
      label="companyAnalysis.ownershipAndGroup.ASSOCIATE_COMPANIES"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadAssociatedCompany({ OrganizationId: organizationId }),
      }}
    >
      <AssociateCompanyTable />
    </Panel>
  )
}
